
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        listSumNumber: number;
        importantNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "WaterCheck",
        setup() {
            let state: State = reactive({
                titleText: '泡水检测',
                titleData: {
                    text: '标准说明',
                    icon:'shuoming.png',
                    clickFun:'showRemind',
                    modelCnt: [
                        '【泡水检测标准】根据检测项目中是否出现泥沙、水印、锈蚀、霉斑等状态和受损程度来综合判断车辆是否有泡水风险。',
                        'prop_up_height',
                        '【泡水车认定标准】座椅滑轨、安全带、座椅座垫底部、车顶篷、行李箱、保险丝盒、发动机舱、点烟器、地胶（毯）、转向柱等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在以下三种或大于三种情况，即认定为泡水车。具体标准详见268V检测认证承诺书附件《268V检测认证标准》。',
                    ]
                },
                defectList: [],
                listName: '泡水检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {soakWater} = data;
                const {importantItemCount,defectItemCount,itemCount,itemList,itemTitle} = soakWater
                state.defectList = itemList
                state.listName = itemTitle
                state.listDefectNumber = defectItemCount
                state.importantNumber = importantItemCount
                state.listSumNumber = itemCount
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
